import PropTypes from "prop-types";
import { Box, DialogContentText } from "@mui/material";

import { LIVE_SYSTEMS } from "../liveTap/liveSystem";

// Option cards follow useSelectLayout's clickable-Box pattern (tabIndex +
// role="button" + Enter/Space), with the accent outline marking the selection.
const optionStyles = {
  border: "1px solid var(--color-border-primary)",
  borderRadius: "8px",
  padding: "12px 16px",
  cursor: "pointer",
  flex: "1 1 220px",
  maxWidth: "340px",
  "&:hover": {
    backgroundColor: "var(--color-bg-tertiary)",
  },
};
const styles = {
  heading: {
    fontWeight: "bold",
    color: "var(--color-text-primary)",
    marginBottom: "4px",
  },
  options: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "8px",
  },
  option: optionStyles,
  selectedOption: {
    ...optionStyles,
    borderColor: "var(--color-accent-primary)",
    outline: "1px solid var(--color-accent-primary)",
  },
  label: {
    fontWeight: 600,
    color: "var(--color-text-primary)",
    marginBottom: "4px",
  },
  blurb: {
    fontSize: "0.8rem",
    color: "var(--color-text-secondary)",
    margin: 0,
  },
};

/**
 * The Live Tapestry system chooser (TT-1046): one card per entry in
 * LIVE_SYSTEMS (classic default, scene experimental — a third is expected).
 * Pure controlled UI; persistence stays with the caller (liveSystem.js).
 */
const LiveSystemSelect = ({ value, onChange, heading = "Tapestry style" }) => (
  <>
    {heading && <DialogContentText sx={styles.heading}>{heading}</DialogContentText>}
    <Box sx={styles.options} role="radiogroup" aria-label={heading || "Tapestry style"}>
      {LIVE_SYSTEMS.map((system) => (
        <Box
          key={system.id}
          sx={value === system.id ? styles.selectedOption : styles.option}
          onClick={() => onChange(system.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              // Keep Enter from reaching window-level "submit" handlers (e.g.
              // CreateTapModal's), which would act on the pre-change selection.
              e.stopPropagation();
              onChange(system.id);
            }
          }}
          tabIndex={0}
          role="radio"
          aria-checked={value === system.id}>
          <DialogContentText sx={styles.label}>{system.label}</DialogContentText>
          <DialogContentText sx={styles.blurb}>{system.blurb}</DialogContentText>
        </Box>
      ))}
    </Box>
  </>
);

LiveSystemSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  heading: PropTypes.string,
};

export default LiveSystemSelect;
